import React from "react";

const SVG = ({
  style = {},
  fill = "#000",
  className = "",
  width="21.95", 
  height="16.935", 
  viewBox="0 0 21.95 16.935"
}) => (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      className={`svg-icon ${className || ""}`}
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="people" transform="translate(1151.496 -2459.957)">
        <path fill={fill} id="Path_331" d="M-1072.392 2469.116c2.232 0 4.041-2.708 4.041-5.237a3.768 3.768 0 0 0-4.041-3.922 3.768 3.768 0 0 0-4.041 3.922c0 2.53 1.809 5.237 4.041 5.237z" className="cls-1" data-name="Path 331" transform="translate(-72.161)" />
        <path fill={fill} id="Path_332" d="M-804.244 2559.419c1.758 0 3.182-2.133 3.182-4.125a2.968 2.968 0 0 0-3.182-3.088 2.968 2.968 0 0 0-3.182 3.088c0 1.992 1.426 4.125 3.182 4.125z" className="cls-1" data-name="Path 332" transform="translate(-330.768 -88.682)" />
        <path fill={fill} id="Path_333" d="M-1129.546 2739.707c-.111-3.259-2.516-4.767-5.466-4.767a6.073 6.073 0 0 0-3.751 1.126 6.957 6.957 0 0 0-5.79-2.476c-3.766 0-6.831 1.935-6.943 6.118a.232.232 0 0 0 .232.238h21.486a.232.232 0 0 0 .232-.239z" className="cls-1" data-name="Path 333" transform="translate(0 -263.053)" />
      </g>
    </svg>
  );

export default SVG;





// WEBPACK FOOTER //
// ./src/components/UI/Icons/People.js